module.exports = __webpack_public_path__ + "img/icon_menu_order.a210cc5c.svg";